import copy from "@virgodev/bazaar/functions/copy";

export interface FieldDef {
  name: string;
  type?: string;
  options?: { name: string; value: string; label?: string }[];
  readonly?: boolean;
  placeholder?: string;
  label?: string | false;
  fields?: FieldDef[];
  size?: number;
  min?: number;
  max?: number;
  step?: number;
  rows?: number;
  cols?: number;
  default?: any;
  required?: boolean;
  pattern?: string;
  css_classes?: string;
  help?: string;
  tabindex?: number;
  maxlength?: number;
  minlength?: number;
  autocomplete?: string;
  extra?: any;
  inlineDisableAdd?: boolean;
  ariaLabel?: string;
  disabled?: boolean;
  focus?: (e: FocusEvent) => void;
}

export function updateModelValue(currentValues, field, rawValue, key = null) {
  // let errors = [];
  // if (field.validators) {
  //   errors = field.validators.map(v => v(value)).filter(e => e);
  // }

  // if (errors.length === 0) {
  const values = copy(currentValues);
  let value = rawValue;
  if (field.type === "number") {
    value = parseFloat(value);
  }
  if (key) {
    if (values[field.name] instanceof Array) {
      const index = values[field.name].indexOf(key);
      if (value) {
        if (index === -1) {
          values[field.name].push(key);
        }
      } else if (index > -1) {
        values[field.name].splice(index, 1);
      }
    } else {
      values[field.name][key] = value;
    }
  } else {
    values[field.name] = value;
  }
  return values;
  // }
}
